import { render, staticRenderFns } from "./SelectWeeks.vue?vue&type=template&id=2edf9ca3"
import script from "./SelectWeeks.vue?vue&type=script&lang=js"
export * from "./SelectWeeks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports